import { render, staticRenderFns } from "./DeliveryActionModal.vue?vue&type=template&id=074e5fd6&"
import script from "./DeliveryActionModal.vue?vue&type=script&lang=js&"
export * from "./DeliveryActionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports